import { fetcher } from '../../lib/api-fetcher';
import type { ExitRequest } from './types';



export async function listSchemeExits(schemeId: string): Promise<ExitRequest[]> {
  return fetcher.get<ExitRequest[]>(`/staff/v1/foreclosure/schemes/${schemeId}/exits`);
}

export async function getExitRequest(id: string): Promise<ExitRequest> {
  return fetcher.get<ExitRequest>(`/staff/v1/foreclosure/exit-requests/${id}`);
}

export async function requestExit(subscriptionId: string, payload: { schemeId: string }): Promise<{ exitId: string }> {
  return fetcher.post<{ exitId: string }>(`/staff/v1/foreclosure/subscriptions/${subscriptionId}/exit-request`, payload);
}

export async function computeSettlement(id: string): Promise<{ success: boolean }> {
  return fetcher.post<{ success: boolean }>(`/staff/v1/foreclosure/exit-requests/${id}/compute-settlement`, {});
}

// Approving the computed settlement is now a real maker!=checker step through the shared
// approvals engine (POST /staff/v1/approvals/EXIT_REFUND/:id/approve, submitted automatically by
// computeSettlement above) -- there is no longer a direct approve-exit endpoint. See
// docs/audits/2026-07-22-scheme-finance-reports-audit.md §2.6/§2.7.

export async function rejectExit(id: string, reason: string): Promise<{ success: boolean }> {
  return fetcher.post<{ success: boolean }>(`/staff/v1/foreclosure/exit-requests/${id}/reject`, { reason });
}

export async function downloadNoc(id: string): Promise<{ documentRef: string }> {
  return fetcher.get<{ documentRef: string }>(`/staff/v1/foreclosure/exit-requests/${id}/noc`);
}
